import React from 'react'
import { Typography } from 'transfix-ui/core'
import { makeStyles } from 'transfix-ui/core/styles'
import { IOfferedShipmentOfferTypeEnum, Maybe } from 'types/FMSGraphqlTypes'
import { ClockIcon } from 'transfix-icons'
import { brandColors } from 'transfix-ui'
import { TEST_IDS } from '../../constants'
import { getOfferExpirationMessage } from '../../utils/getOfferExpirationMessage'
import { getRemainingTimeInMinutes } from '../../utils/getRemainingTimeInMinutes'

export interface IShipmentOfferRowExpirationProps {
  offerExpiresAt: Maybe<string>
  offerType: IOfferedShipmentOfferTypeEnum
}

const useShipmentOfferRowExpirationStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  clockIcon: {
    marginRight: theme.spacing(0.5),
  },
}))

const ShipmentOfferRowExpiration = ({
  offerExpiresAt,
  offerType,
}: IShipmentOfferRowExpirationProps) => {
  const { shipmentOfferRowExpiration } = TEST_IDS
  const styles = useShipmentOfferRowExpirationStyles()

  const isDedicatedOffer = offerType === IOfferedShipmentOfferTypeEnum.WaterfallOffered

  const remainingTime = getRemainingTimeInMinutes(offerExpiresAt)

  const isOfferExpiringSoon = remainingTime < 5
  const showClockIcon = !isDedicatedOffer && isOfferExpiringSoon
  const textColor = showClockIcon ? brandColors.warning1 : brandColors.coolGray5

  const text = getOfferExpirationMessage({ offerExpiresAt, offerType })
  return (
    <div className={styles.root} data-test={shipmentOfferRowExpiration.container}>
      {showClockIcon && (
        <ClockIcon
          size='medium'
          color='warning1'
          data-test={shipmentOfferRowExpiration.clockIcon}
          className={styles.clockIcon}
        />
      )}
      <Typography
        variant='caption'
        style={{ color: textColor }}
        data-test={shipmentOfferRowExpiration.expirationText}>
        {text}
      </Typography>
    </div>
  )
}

export default ShipmentOfferRowExpiration
